// extracted by mini-css-extract-plugin
export default {"wrapper":"vx-z","response":"wx-z","error":"xx-z","disabled":"yx-z","buttons":"zx-z","feedbackQuestionSection":"Ax-z","yesNoWrapper":"Bx-z"};